/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import { GetAccount200ResponsePositionsInner } from "../../codegen-api";
import { SPACING } from "../../constants/design/spacing";
import { usePositionTpslDisplay } from "../../hooks/tpsl/useTpslDisplay";
import RowActionButton from "../shared/RowActionButton";
import { Align, TPSLCell, TPSLContainer } from "../shared/Table/style";

interface ITpslCellProps {
  position: GetAccount200ResponsePositionsInner;
  pricePrecision: number;
  /** Opens TPSLForPositionModal for this position. */
  onEdit: (positionId: string) => void;
  positionId: string;
}

/**
 * Desktop TP/SL cell: the position's live take-profit / stop-loss trigger
 * prices plus an edit affordance. Positions with no triggers get an "Add"
 * button instead. Lookup and formatting are shared with the tablet card and the
 * mobile row via usePositionTpslDisplay.
 */
function TpslCell({
  position,
  pricePrecision,
  onEdit,
  positionId,
}: ITpslCellProps) {
  const { takeProfitLabel, stopLossLabel, hasTriggers } =
    usePositionTpslDisplay(position, pricePrecision);

  return (
    <Align align="right">
      <TPSLContainer
        style={{ alignItems: "center", justifyContent: "flex-end" }}
      >
        {hasTriggers ? (
          <>
            <TPSLCell>
              <span>{takeProfitLabel}</span>
              <span>{stopLossLabel}</span>
            </TPSLCell>
            <RowActionButton
              variant="edit"
              aria-label="Edit take profit / stop loss"
              style={{ marginLeft: SPACING.two }}
              onClick={() => onEdit(positionId)}
            />
          </>
        ) : (
          <RowActionButton
            variant="text"
            text="Add"
            aria-label="Add take profit / stop loss"
            onClick={() => onEdit(positionId)}
          />
        )}
      </TPSLContainer>
    </Align>
  );
}

export default TpslCell;
